import { formatDateStringDDMMYYYY } from './dateStringDDMMYYYY'

export function formatDateStringOrNullDDMMYYYY(dateString: string | null): string {
  if (dateString === null) {
    return ''
  }
  return formatDateStringDDMMYYYY(dateString)
}